// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"241":"900c15e3122e923b5ce5","488":"bcea72c93cd657a63ef6","532":"7ea257594c81849b51b2","592":"948f2371ffa9b8f89225","736":"f763930f172f8d281776"}[chunkId] + ".js";
};